import { CardWithTabs } from "../../../components/CardWithTabs";
import UsersList from "./components/UsersList";
import ReportsList from "./components/ReportsList";
import UsersPage from "./components/UsersPage";

export default function users() {
  const tabs = [
    {
      name: "Users",
      component: <UsersPage />,
    },
    {
      name: "Reports",
      component: <ReportsList />,
    },
  ];
  return (
    <>
      <CardWithTabs name={tabs.name} tabs={tabs} />
    </>
  );
}
